export default __webpack_public_path__ + "static/media/icon_hamburger.ddd26506.svg";